/** Placeholder wall imagery. Swap these for real PIXUB generations before launch. */
export const wallImages = [
  "https://picsum.photos/id/1011/600/600",
  "https://picsum.photos/id/1015/600/600",
  "https://picsum.photos/id/1016/600/600",
  "https://picsum.photos/id/1018/600/600",
  "https://picsum.photos/id/1020/600/600",
  "https://picsum.photos/id/1024/600/600",
  "https://picsum.photos/id/1025/600/600",
  "https://picsum.photos/id/1027/600/600",
  "https://picsum.photos/id/1035/600/600",
  "https://picsum.photos/id/1036/600/600",
  "https://picsum.photos/id/1039/600/600",
  "https://picsum.photos/id/1040/600/600",
  "https://picsum.photos/id/1043/600/600",
  "https://picsum.photos/id/1044/600/600",
  "https://picsum.photos/id/1047/600/600",
  "https://picsum.photos/id/1050/600/600",
  "https://picsum.photos/id/1052/600/600",
  "https://picsum.photos/id/1059/600/600",
  "https://picsum.photos/id/1062/600/600",
  "https://picsum.photos/id/1069/600/600",
  "https://picsum.photos/id/1074/600/600",
  "https://picsum.photos/id/1080/600/600",
  "https://picsum.photos/id/1084/600/600",
  "https://picsum.photos/id/106/600/600",
  "https://picsum.photos/id/110/600/600",
  "https://picsum.photos/id/119/600/600",
  "https://picsum.photos/id/133/600/600",
  "https://picsum.photos/id/164/600/600",
  "https://picsum.photos/id/177/600/600",
  "https://picsum.photos/id/180/600/600",
  "https://picsum.photos/id/200/600/600",
  "https://picsum.photos/id/206/600/600",
  "https://picsum.photos/id/219/600/600",
  "https://picsum.photos/id/237/600/600",
  "https://picsum.photos/id/250/600/600",
  "https://picsum.photos/id/292/600/600",
  "https://picsum.photos/id/301/600/600",
  "https://picsum.photos/id/338/600/600",
  "https://picsum.photos/id/357/600/600",
  "https://picsum.photos/id/433/600/600",
];
